/** Filter fields of the voucher list; kept here without imports so tests can load it. */
type VoucherListSearch = {
    code?: string;
    page?: number;
    size?: number;
};

/**
 * Query of the Excel export (#1904): the list filter without paging, the export
 * always contains every matching voucher.
 */
export const getVouchersExportSearchParams = (
    params: VoucherListSearch
): Omit<VoucherListSearch, 'page' | 'size'> => {
    const filter = { ...params };
    delete filter.page;
    delete filter.size;
    return filter;
};
